import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { WaterfallFilterStorage, WaterfallFilterType } from '@bingads-webui-campaign/filter-storage';
import { withWaterfallFilterStorage } from '@bingads-webui-campaign-react/with-waterfall-filter-storage';
import { urlFilterType } from '@bingads-webui-campaign/url-filter-metadata';
import { entityNameFilterType } from '@bingads-webui-campaign/entity-name-filter-metadata';
import { GlobalFilterContext } from '@bingads-webui-react/global-filter-context';

const SupportedWaterfallFilters = [
  WaterfallFilterType.CampaignType,
  WaterfallFilterType.CampaignStatus,
  WaterfallFilterType.AdGroupStatus,
  WaterfallFilterType.DateFilter,
];

export class GFContextProvider extends React.PureComponent {
  constructor(props) {
    super(props);

    const { waterfallFilterStorage } = props;

    const waterfallFilters = waterfallFilterStorage.getFilters(SupportedWaterfallFilters);

    if (waterfallFilters.length !== SupportedWaterfallFilters.length) {
      throw new Error('Incorrect count of waterfall filters returned from waterfall filter storage.');
    }

    const waterfallFiltersState = _.object(
      SupportedWaterfallFilters,
      waterfallFilters.map(f => f && f.filter)
    );

    const urlFiltersState = _.reduce(urlFilterType, (memo, urlFilter) => _.extend(memo, { [urlFilter]: '' }), {});

    const entityNameFiltersState = _.reduce(entityNameFilterType, (memo, entityNameFilter) => _.extend(memo, { [entityNameFilter]: '' }), {});

    this.state = {
      ...waterfallFiltersState,
      ...urlFiltersState,
      ...entityNameFiltersState,
    };
  }

  updateWaterfallFilter = ({
    filterType, filter,
  }) => {
    this.props.waterfallFilterStorage.save(filterType, filter);

    this.setState({
      [filterType]: filter,
    });
  }

  updateUrlFilter = ({
    filterType, filter,
  }) => {
    this.setState({
      [filterType]: filter,
    });
  }

  updateEntityNameFilter = ({
    filterType, filter,
  }) => {
    this.setState({
      [filterType]: filter,
    });
  }

  render() {
    return (
      <GlobalFilterContext.Provider value={{
        updateWaterfallFilter: this.updateWaterfallFilter,
        updateUrlFilter: this.updateUrlFilter,
        updateEntityNameFilter: this.updateEntityNameFilter,
        ...this.state,
      }}
      >
        {this.props.children}
      </GlobalFilterContext.Provider>
    );
  }
}

GFContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  waterfallFilterStorage: PropTypes.instanceOf(WaterfallFilterStorage).isRequired,
};

export const GlobalFilterContextProvider =
  withWaterfallFilterStorage(GFContextProvider);
